import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';
import themeServices from '../../themes/ThemeServices';

import styles from './RoomScan.scss';
import stateCacheService from '../../services/StateCache';
import liveSessioner from '../../services/livesession/LiveSessioner';
import navigationService from '../../services/NavigationService';
import storeManager from '../../store/StoreManager';
import livestreamActions from '../../actions/LivestreamActions';

class RoomScan extends React.PureComponent {
    static propTypes = {
        isConfirmed: PropTypes.bool,
        webcamStream: PropTypes.object,
        shouldShowInstructions: PropTypes.bool,
    };

    setWebcamRef = (element) => {
        const { webcamStream } = this.props;
        this.webcam = element;

        if (this.webcam) {
            this.webcam.srcObject = webcamStream;
            this.webcam.volume = 0.001; // volume = 0 as well as 'mute' prevents video from rendering.
        }
    }

    handleToggleRoomScanConfirmation = () => {
        const { isConfirmed } = this.props;
        stateCacheService.getStateCacheInstance().setRoomScanConfirmationStatus(!isConfirmed);
        storeManager.dispatch(
            livestreamActions.setRoomScanConfirmation(!isConfirmed)
        );
    }

    handleCloseRoomScan() {
        navigationService.navigateToTestOverview();
    }

    render() {
        const { isConfirmed, shouldShowInstructions } = this.props;
        return (
            <React.Fragment>
                <div className={styles.body} role="main">
                    <h2>{t('roomScan.title')}</h2>
                    <div className={styles.roomScanDesc}>{t('roomScan.description')}</div>
                    {/* eslint-disable-next-line */}
                    <video
                        id="roomScan_livestream"
                        ref={this.setWebcamRef}
                        autoPlay
                    />
                    {shouldShowInstructions && (
                        <h4 className={styles.confirmInstructions}>{t('roomScan.confirmInstructions')}</h4>
                    )}
                    <div className={styles.checkBoxWrapper}>
                        <input
                            type="checkbox"
                            id="roomScanConfirm"
                            className={styles.roomScanInput}
                            name="roomScanConfirm"
                            checked={isConfirmed}
                            onChange={this.handleToggleRoomScanConfirmation}
                        />
                        <label htmlFor="roomScanConfirm" className={styles.roomScanLabel}>
                            {t('roomScan.confirmRoomScan')}
                        </label>
                    </div>
                    <button
                        className={`${styles.roomScanButton} btn`}
                        onClick={this.handleCloseRoomScan}
                        disabled={!isConfirmed}
                        aria-label={t('roomScan.returnToTestOverview')}
                    >
                        <i className="fa fa-arrow-right" aria-hidden />
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        isConfirmed: state.livestream.isRoomScanConfirmed || stateCacheService.getStateCacheInstance().isRoomScanConfirmed(),
        webcamStream: liveSessioner.getGrantedStream(),
        shouldShowInstructions: themeServices.isIelts() || themeServices.isCeq(),
    };
}

const RoomScanContainer = connect(mapStateToProps)(RoomScan);
export default RoomScanContainer;
